if (!customElements.get('collage-hero-overlap')) {
  class CollageHeroOverlap extends HTMLElement {
    connectedCallback() {
      this.hero = this.querySelector('[data-collage-hero]');
      this.isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.scheduleResize = this.scheduleResize.bind(this);
      this.rafId = null;
      this.resizeTimer = null;
      this.section = this.closest('.shopify-section');

      this.resizeObserver = new ResizeObserver(this.scheduleResize);
      if (this.section) this.resizeObserver.observe(this.section);
      if (this.hero) this.resizeObserver.observe(this.hero);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.scheduleResize);

      this.handleResize();
      this.handleScroll();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.scheduleResize);
      if (this.rafId) cancelAnimationFrame(this.rafId);
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
    }

    scheduleResize() {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.handleResize();
      }, 80);
    }

    handleResize() {
      this.updateOverlap();
      this.handleScroll();
    }

    handleScroll() {
      if (!this.hero) return;
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const enableParallax = this.hero.dataset.parallaxEnabled === 'true' && !this.isDesignMode && !prefersReducedMotion;

        if (!enableParallax) {
          this.hero.style.setProperty('--collage-hero-background-shift', '0px');
          this.hero.style.setProperty('--collage-hero-block-shift', '0px');
          return;
        }

        const rect = this.hero.getBoundingClientRect();
        const viewportHeight = window.innerHeight || 1;
        const centerOffset = viewportHeight * 0.5 - (rect.top + rect.height * 0.5);
        const progress = Math.max(-1, Math.min(1, centerOffset / viewportHeight));

        this.hero.style.setProperty('--collage-hero-background-shift', `${progress * 48}px`);
        this.hero.style.setProperty('--collage-hero-block-shift', `${progress * -60}px`);
      });
    }

    updateOverlap() {
      const countBelow = Number.parseInt(this.dataset.countBelow || '0', 10);
      const outerSection = this.closest('.shopify-section');

      if (!outerSection || !countBelow) {
        this.style.setProperty('--collage-hero-overlap-bottom', '0px');
        return;
      }

      let overlapBottomHeight = 0;
      let section = outerSection;

      for (let index = 0; index < countBelow; index += 1) {
        if (!section.nextElementSibling) break;
        section = section.nextElementSibling;
        overlapBottomHeight += section.getBoundingClientRect().height;
      }

      this.style.setProperty('--collage-hero-overlap-bottom', `${overlapBottomHeight}px`);
    }
  }

  customElements.define('collage-hero-overlap', CollageHeroOverlap);
}

function refreshCollageHeroSections() {
  requestAnimationFrame(() => {
    document.querySelectorAll('collage-hero-overlap').forEach((element) => {
      if (typeof element.handleResize === 'function') element.handleResize();
    });
  });
}

if (!window.__collageHeroOverlapEditorEventsBound) {
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest('.collage-hero__block');
    if (!block) return;

    requestAnimationFrame(() => {
      block.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    });
  });

  document.addEventListener('shopify:section:load', refreshCollageHeroSections);
  document.addEventListener('shopify:section:unload', refreshCollageHeroSections);
  document.addEventListener('shopify:section:reorder', refreshCollageHeroSections);

  window.__collageHeroOverlapEditorEventsBound = true;
}